import { warehouseApi } from "~/redux/warehouse/warehouseApi";
import { PartiallyCompleteRequest } from "~/types/api";

import { publicApi } from "./publicApi";

const picksApi = publicApi.injectEndpoints({
  endpoints: (build) => ({
    partiallyComplete: build.mutation<
      void,
      {
        pickId: string;
        requestBody: PartiallyCompleteRequest;
        clientId: string;
        fulfillmentCenterId: string;
      }
    >({
      query: ({ pickId, requestBody }) => ({
        url: `/picks/${pickId}/partially-complete`,
        method: "POST",
        body: requestBody
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(warehouseApi.util.invalidateTags(["focused pick", "tote"]));
        } catch {
          return;
        }
      }
    })
  }),
  overrideExisting: false
});

export default picksApi;
